export enum ReminderType {
  IN_X_MINUTES = 0,
  IN_X_HOURS = 1,
  NEXT_DAY = 2,
  NEXT_WEEK = 3
}

export enum DaysEnum {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6
}

export type BaseReminder = {
  type: ReminderType;
};

export type MinutesReminder = BaseReminder & {
  minutes: number;
};

export type HoursReminder = BaseReminder & {
  hours: number;
};

export type NextDayReminder = BaseReminder & {
  hour: number;
};

export type NextWeekReminder = BaseReminder & {
  hour: number;
  dayOfWeek: DaysEnum;
};

export type TimeReminder =
  | MinutesReminder
  | HoursReminder
  | NextDayReminder
  | NextWeekReminder;

export class ReminderTimeDefaults {
  static nextWeek: NextWeekReminder = {
    type: ReminderType.NEXT_WEEK,
    dayOfWeek: DaysEnum.MONDAY,
    hour: 6
  };
  static nextDay: NextDayReminder = {
    type: ReminderType.NEXT_DAY,
    hour: 6
  };
  static inOneHour: HoursReminder = {
    type: ReminderType.IN_X_HOURS,
    hours: 1
  };
  static inOneMinute: MinutesReminder = {
    type: ReminderType.IN_X_MINUTES,
    minutes: 1
  };
}

export class ReminderTimeFactory {
  static create(reminderProperties: TimeReminder): Date {
    const now: Date = new Date();
    switch (reminderProperties.type) {
    case ReminderType.IN_X_MINUTES: {
      return new Date(
        now.getTime() +
              1000 * 60 * (reminderProperties as MinutesReminder).minutes
      );
    }
    case ReminderType.IN_X_HOURS: {
      return new Date(
        now.getTime() +
              1000 * 60 * 60 * (reminderProperties as HoursReminder).hours
      );
    }
    case ReminderType.NEXT_DAY: {
      const approxNextDay: Date = new Date(
        now.getTime() + 1000 * 60 * 60 * 24
      );
      const resultNextDay: Date = new Date(
        approxNextDay.getFullYear(),
        approxNextDay.getMonth(),
        approxNextDay.getDate(),
        (reminderProperties as NextDayReminder).hour,
        0,
        0,
        0
      );
      return resultNextDay;
    }
    case ReminderType.NEXT_WEEK: {
      const approxNextWeek: Date = new Date(
        now.getTime() +
              1000 *
                60 *
                60 *
                24 *
                (((7 - (reminderProperties as NextWeekReminder).dayOfWeek) % 7) +
                  1)
      );
      const resultNextWeek: Date = new Date(
        approxNextWeek.getFullYear(),
        approxNextWeek.getMonth(),
        approxNextWeek.getDate(),
        (reminderProperties as NextWeekReminder).hour,
        0,
        0,
        0
      );
      return resultNextWeek;
    }
    default:
      throw new Error('create has been called with invalid parameters');
    }
  }
}
